import React from "react";

const EventModal = ({ event, onClose }) => {
  if (!event) return null;

  return (
    <div onClick={onClose} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-xl w-[450px] overflow-hidden shadow-2xl">

        {/* Header */}
        <div className="bg-red-600 text-white p-6 relative">

          <button
            onClick={onClose}
            className="absolute right-4 top-4 text-xl"
          >
            ✕
          </button>

          <p className="uppercase text-xs tracking-[0.2em]">
            {new Date(event.start).toLocaleDateString("en-IN", { weekday: "long" })}
          </p>

          <h1 className="text-5xl font-bold leading-none mt-2">
            {new Date(event.start).getDate()}
            <sup className="text-lg align-top">th</sup>
          </h1>

          <h3 className="text-xl mt-3 font-semibold">
            {new Date(event.start).toLocaleDateString("en-IN", {
              month: "long",
              year: "numeric",
            })}
          </h3>

          <p className="mt-3 text-sm">
            {event.extendedProps.gujaratiMonth} · {event.extendedProps.paksh} · {event.extendedProps.tithi} · Samvat {event.extendedProps.samvat}
          </p>

          <p className="text-sm mt-1">
            Nakshatra : {event.extendedProps.nakshatra}
          </p>

          <p className="text-sm mt-1">
            Chandra : {event.extendedProps.chandraRashi}
          </p>

        </div>

        {/* Body */}

        <div className="p-6 space-y-3">

          {event.extendedProps.imageId?.imageUrl && (
            <img
              src={`https://smvdocuments.s3.amazonaws.com/${event.extendedProps.imageId.imageUrl}`}
              alt={event.extendedProps.imageId.title || "Festival"}
              className="w-20 h-20 object-contain mx-auto mb-4"
            />
          )}

          <h2 className="font-semibold">Description:</h2>

          <p className="leading-7 text-gray-700">
            {event.extendedProps.description}
          </p>

        </div>

        {/* Footer */}

        <div className="border-t grid grid-cols-2 text-center p-4 text-sm">
          <div>🌅 Sunrise 6:08</div>
          <div>🌇 Sunset 7:32</div>
        </div>

      </div>
    </div>
  );
};

export default EventModal;